export class SIQSliderCardTheme {
  thumbBorderColor = "null";
  selectedTrackColor = "null";
  selectedValueTextColor = "null";
  unSelectedTrackColor = "null";
  thumbBackgroundColor = "null";
  minRangeTextColor = "null";
  maxRangeTextColor = "null";
}
//# sourceMappingURL=SIQSliderCardTheme.js.map